<div fxLayout="row" fxLayoutAlign="end center">
  <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div fxLayout="column" fxLayoutAlign="center center">
  <label mat-dialog-title class="otpHeader">Select Template</label>
  <p>This is visible as your miniapps profile icon</p>
</div>
<div fxLayout="column">
  <div class="form-group" fxLayout="row" fxLayoutGap="2px" style="position: relative">
    <label class="responsive-margin-right-5">
      <input type="radio" name="profilePhoto" id="option1" formControlName="profilePhoto" value="1"
        class="card-input-element" (change)="onChangeIcon($event)" />
      <div fxLayout="column" class="miniapps-img card-input" fxLayoutAlign="center center">
        <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;">
        </div>

        <div fxLayout="column" fxLayoutAlign="center center" style="flex-direction: column;
        box-sizing: border-box;
        display: flex;
        place-content: center;
        align-items: center;">
          <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <circle cx="26.051" cy="26.051" r="26.051" fill="#FCF3D3" />
            </svg>
          </div>
          <div class="template-icon-img"><img src="assets/bots1-icon.svg" /></div>
        </div>

      </div>
    </label>
    <label class="responsive-margin-right-5">
      <input type="radio" name="profilePhoto" id="option2" formControlName="profilePhoto" value="2"
        class="card-input-element" (change)="onChangeIcon($event)" />
      <div fxLayout="column" class="miniapps-img card-input" fxLayoutAlign="center center">
        <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;">
        </div>

        <div fxLayout="column" fxLayoutAlign="center center" style="flex-direction: column;
        box-sizing: border-box;
        display: flex;
        place-content: center;
        align-items: center;">
          <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <circle cx="26.051" cy="26.051" r="26.051" fill="#C5F3F1" />
            </svg>
          </div>
          <div class="template-icon-img"><img src="assets/bots1-icon.svg" /></div>
        </div>

      </div>
    </label>
    <label class="responsive-margin-right-5">
      <input type="radio" name="profilePhoto" id="option3" formControlName="profilePhoto" value="3"
        class="card-input-element" (change)="onChangeIcon($event)" />
      <div fxLayout="column" class="miniapps-img card-input" fxLayoutAlign="center center">
        <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;">
        </div>

        <div fxLayout="column" fxLayoutAlign="center center" style="flex-direction: column;
        box-sizing: border-box;
        display: flex;
        place-content: center;
        align-items: center;">
          <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <circle cx="26.051" cy="26.051" r="26.051" fill="#FFE5D5" />
            </svg>
          </div>
          <div class="template-icon-img"><img src="assets/bots1-icon.svg" /></div>
        </div>

      </div>
    </label>
    <label>
      <input type="radio" name="profilePhoto" id="option4" formControlName="profilePhoto" value="4"
        class="card-input-element" (change)="onChangeIcon($event)" />
      <div fxLayout="column" class="miniapps-img card-input" fxLayoutAlign="center center">
        <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;">
        </div>

        <div fxLayout="column" fxLayoutAlign="center center" style="flex-direction: column;
        box-sizing: border-box;
        display: flex;
        place-content: center;
        align-items: center;">
          <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
            </svg>
          </div>
          <div class="template-icon-img"><img src="assets/bots1-icon.svg" /></div>
        </div>

      </div>
    </label>
  </div>
</div>
<!-- </div> -->
<div fxLayout="row" fxLayoutAlign="center center"
  style="width: 100%;flex-direction: row;box-sizing: border-box;display: flex;place-content: center;align-items: center;">
  <button type="button" class="verify-btn" fxFlex="33" fxLayoutAlign="center center" style="padding: 10px 0px;
  place-content: center;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 100%;
  max-width: 33%;" (click)="closePopup()">Cancel
  </button>
  <button class="verify-btn" fxLayoutAlign="center center" fxFlex="30" style="background: rgb(56, 106, 246);
  color: rgb(255, 255, 255);
  font-family: Montserrat;
  padding: 10px 0px;
  place-content: center;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 100%;
  font-style: normal;
  font-size: 14px;
  max-width: 30%;
" (click)="saveIcon()">Save
  </button>
</div>